var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsXl: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "302 -21 286 286",
    width: 286,
    height: 286,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Baskerville",
    fontSize: 82,
    panose1: "2 2 7 2 7 4 0 2 2 3",
    unitsPerEm: 1000,
    underlinePosition: -100.09766,
    underlineThickness: 49.80469,
    slope: 0,
    xHeight: 399.90234,
    capHeight: 670.8984,
    ascent: 895.9961,
    descent: -247.0703,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("fontFaceSrc", null, /*#__PURE__*/React.createElement("fontFaceName", {
    name: "Baskerville-SemiBold"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1",
    stroke: "none",
    fillOpacity: 1,
    strokeOpacity: 1,
    strokeDasharray: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Canvas 1"), /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1: Layer 2"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 2"), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 351.7466 35.62071 L 474.01504 9.631751 C 479.9574 8.36866 485.7986 12.16197 487.0617 18.104346 L 524.6937 195.14906 C 525.9568 201.09144 522.1635 206.93262 516.2211 208.19571 L 393.95266 234.18467 C 388.0103 235.44777 382.1691 231.65446 380.906 225.71208 L 343.274 48.667364 C 342.0109 42.72499 345.8042 36.883803 351.7466 35.62071 Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 351.7466 35.62071 L 474.01504 9.631751 C 479.9574 8.36866 485.7986 12.16197 487.0617 18.104346 L 524.6937 195.14906 C 525.9568 201.09144 522.1635 206.93262 516.2211 208.19571 L 393.95266 234.18467 C 388.0103 235.44777 382.1691 231.65446 380.906 225.71208 L 343.274 48.667364 C 342.0109 42.72499 345.8042 36.883803 351.7466 35.62071 Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_41"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 361.29716,
    cy: 67.22827,
    r: 8.8888648153106,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.29716,
    cy: 67.22827,
    r: 8.8888648153106,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_40"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 366.9941,
    cy: 49.91961,
    r: 8.8888648153106,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.9941,
    cy: 49.91961,
    r: 8.8888648153106,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_39"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.1832,
    cy: 63.42647,
    r: 8.88886481531058,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1832,
    cy: 63.42647,
    r: 8.88886481531058,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 377.7059 79.48081 C 376.6644 77.75487 375.41625 73.95825 374.683 70.508475 C 374.54995 69.88261 374.2251 68.35425 374.10134 67.77206 L 367.76255 69.11941 C 367.8863 69.7016 368.21116 71.22996 368.3442 71.85583 C 369.07746 75.3056 369.48145 79.28166 369.232 81.28198 L 377.7059 79.48081 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.7059 79.48081 C 376.6644 77.75487 375.41625 73.95825 374.683 70.508475 C 374.54995 69.88261 374.2251 68.35425 374.10134 67.77206 L 367.76255 69.11941 C 367.8863 69.7016 368.21116 71.22996 368.3442 71.85583 C 369.07746 75.3056 369.48145 79.28166 369.232 81.28198 L 377.7059 79.48081 Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 371.1616 54.79439 C 373.43483 57.35308 374.4378 62.071745 373.4018 65.33384 C 372.3658 68.59594 369.68314 69.16616 367.4099 66.60746 C 365.13663 64.04877 364.13365 59.330105 365.16966 56.068013 C 366.20566 52.80591 368.88833 52.23569 371.1616 54.79439",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 371.1616 54.79439 C 373.43483 57.35308 374.4378 62.071745 373.4018 65.33384 C 372.3658 68.59594 369.68314 69.16616 367.4099 66.60746 C 365.13663 64.04877 364.13365 59.330105 365.16966 56.068013 C 366.20566 52.80591 368.88833 52.23569 371.1616 54.79439",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 503.04244,
    cy: 176.7642,
    r: 8.88886481531059,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.04244,
    cy: 176.7642,
    r: 8.88886481531059,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_34"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 497.3455,
    cy: 194.07286,
    r: 8.88886481531056,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.3455,
    cy: 194.07286,
    r: 8.88886481531056,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_33"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 485.1564,
    cy: 180.566,
    r: 8.8888648153106,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.1564,
    cy: 180.566,
    r: 8.8888648153106,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 486.6337 164.51166 C 487.6752 166.2376 488.92335 170.03422 489.6566 173.484 C 489.78965 174.10985 490.1145 175.63822 490.23826 176.2204 L 496.57705 174.87306 C 496.4533 174.29087 496.12844 172.7625 495.9954 172.13664 C 495.26214 168.68687 494.85815 164.71081 495.1076 162.71048 L 486.6337 164.51166 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 486.6337 164.51166 C 487.6752 166.2376 488.92335 170.03422 489.6566 173.484 C 489.78965 174.10985 490.1145 175.63822 490.23826 176.2204 L 496.57705 174.87306 C 496.4533 174.29087 496.12844 172.7625 495.9954 172.13664 C 495.26214 168.68687 494.85815 164.71081 495.1076 162.71048 L 486.6337 164.51166 Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 493.178 189.19807 C 490.90477 186.6394 489.9018 181.92072 490.9378 178.65863 C 491.9738 175.39653 494.65646 174.8263 496.9297 177.385 C 499.20297 179.9437 500.20595 184.66236 499.16994 187.92445 C 498.13394 191.18656 495.45127 191.75678 493.178 189.19807",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 493.178 189.19807 C 490.90477 186.6394 489.9018 181.92072 490.9378 178.65863 C 491.9738 175.39653 494.65646 174.8263 496.9297 177.385 C 499.20297 179.9437 500.20595 184.66236 499.16994 187.92445 C 498.13394 191.18656 495.45127 191.75678 493.178 189.19807",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_29"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(388.05422 75.51939) rotate(-12)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Baskerville",
    fontSize: 82,
    fontWeight: 600,
    fill: "black",
    x: 0,
    y: 73
  }, "Q")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 452.9657 14.287029 L 575.23415 40.27599 C 581.1765 41.53908 584.9698 47.380266 583.70674 53.32264 C 583.70674 53.32264 583.70674 53.32264 583.70674 53.32264 L 546.0747 230.36736 C 544.81163 236.30973 538.97045 240.10304 533.0281 238.83995 L 410.7596 212.851 C 404.81725 211.5879 401.02394 205.74672 402.28703 199.80434 C 402.28703 199.80434 402.28703 199.80434 402.28703 199.80434 L 439.91904 22.759624 C 441.18214 16.817248 447.0233 13.023938 452.9657 14.287029 Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 452.9657 14.287029 L 575.23415 40.27599 C 581.1765 41.53908 584.9698 47.380266 583.70674 53.32264 C 583.70674 53.32264 583.70674 53.32264 583.70674 53.32264 L 546.0747 230.36736 C 544.81163 236.30973 538.97045 240.10304 533.0281 238.83995 L 410.7596 212.851 C 404.81725 211.5879 401.02394 205.74672 402.28703 199.80434 C 402.28703 199.80434 402.28703 199.80434 402.28703 199.80434 L 439.91904 22.759624 C 441.18214 16.817248 447.0233 13.023938 452.9657 14.287029 Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 448.8346,
    cy: 47.046537,
    r: 8.88886481531058,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.8346,
    cy: 47.046537,
    r: 8.88886481531058,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 461.0791,
    cy: 33.55144,
    r: 8.88886481531061,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461.0791,
    cy: 33.55144,
    r: 8.88886481531061,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_10"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 466.7207,
    cy: 50.848335,
    r: 8.88886481531058,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.7207,
    cy: 50.848335,
    r: 8.88886481531058,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 458.8412 64.91381 C 458.59174 62.913486 458.99573 58.93743 459.729 55.487656 C 459.86203 54.861794 460.1869 53.33343 460.31064 52.75124 L 453.97185 51.40389 C 453.8481 51.98608 453.52324 53.51444 453.3902 54.140305 C 452.65694 57.59008 451.4088 61.3867 450.3673 63.112636 L 458.8412 64.91381 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 458.8412 64.91381 C 458.59174 62.913486 458.99573 58.93743 459.729 55.487656 C 459.86203 54.861794 460.1869 53.33343 460.31064 52.75124 L 453.97185 51.40389 C 453.8481 51.98608 453.52324 53.51444 453.3902 54.140305 C 452.65694 57.59008 451.4088 61.3867 450.3673 63.112636 L 458.8412 64.91381 Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 462.90353 39.699844 C 463.93954 42.961935 462.93656 47.680603 460.6633 50.23929 C 458.39006 52.79799 455.7074 52.22777 454.6714 48.965666 C 453.6354 45.703575 454.63836 40.984907 456.9116 38.42622 C 459.18486 35.86752 461.86753 36.43774 462.90353 39.699844",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 462.90353 39.699844 C 463.93954 42.961935 462.93656 47.680603 460.6633 50.23929 C 458.39006 52.79799 455.7074 52.22777 454.6714 48.965666 C 453.6354 45.703575 454.63836 40.984907 456.9116 38.42622 C 459.18486 35.86752 461.86753 36.43774 462.90353 39.699844",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 533.7731,
    cy: 204.76558,
    r: 8.88886481531057,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.7731,
    cy: 204.76558,
    r: 8.88886481531057,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 521.5286,
    cy: 218.26068,
    r: 8.88886481531055,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.5286,
    cy: 218.26068,
    r: 8.88886481531055,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 515.88705,
    cy: 200.96378,
    r: 8.88886481531056,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.88705,
    cy: 200.96378,
    r: 8.88886481531056,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 523.76655 186.8983 C 524.016 188.89863 523.612 192.8747 522.8787 196.32446 C 522.7457 196.95032 522.42083 198.47869 522.2971 199.06088 L 528.6359 200.40823 C 528.7596 199.82604 529.0845 198.29768 529.2175 197.67181 C 529.9508 194.22204 531.19894 190.42542 532.2404 188.69948 L 523.76655 186.8983 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 523.76655 186.8983 C 524.016 188.89863 523.612 192.8747 522.8787 196.32446 C 522.7457 196.95032 522.42083 198.47869 522.2971 199.06088 L 528.6359 200.40823 C 528.7596 199.82604 529.0845 198.29768 529.2175 197.67181 C 529.9508 194.22204 531.19894 190.42542 532.2404 188.69948 L 523.76655 186.8983 Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 519.7042 212.11228 C 518.6682 208.85018 519.6712 204.13152 521.9444 201.57283 C 524.2177 199.01413 526.90035 199.58435 527.93634 202.84645 C 528.97235 206.10854 527.9694 210.8272 525.6961 213.3859 C 523.42287 215.9446 520.7402 215.37438 519.7042 212.11228",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 519.7042 212.11228 C 518.6682 208.85018 519.6712 204.13152 521.9444 201.57283 C 524.2177 199.01413 526.90035 199.58435 527.93634 202.84645 C 528.97235 206.10854 527.9694 210.8272 525.6961 213.3859 C 523.42287 215.9446 520.7402 215.37438 519.7042 212.11228",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_26"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(469.9061 65.50393) rotate(12)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Baskerville",
    fontSize: 82,
    fontWeight: 600,
    fill: "black",
    x: 0,
    y: 73
  }, "Q"))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.5dc8241f932d22b5523a37a905b73e46.svg";